(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('.announcement-bar');
    var dismissBtn = bar && bar.querySelector('[data-dismiss]');
    if (bar && dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        bar.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var overlay = drawer.querySelector('.js-drawer-overlay');
  var closeBtn = drawer.querySelector('.js-drawer-close');
  var triggerEl = null;

  function openDrawer() {
    triggerEl = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', handleKeyDown);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', handleKeyDown);
    if (triggerEl) triggerEl.focus();
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.querySelectorAll('[data-open-cart-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  function refreshDrawer(cartJson, autoOpen) {
    if (cartJson) updateCartCount(cartJson.item_count);
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) return;
        var wrapper = document.getElementById('shopify-section-cart-drawer');
        if (!wrapper) return;
        var wasOpen = drawer && (drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false');
        wrapper.innerHTML = data['cart-drawer'];
        drawer = wrapper.querySelector('#cart-drawer');
        if (!drawer) return;
        overlay = drawer.querySelector('.js-drawer-overlay');
        closeBtn = drawer.querySelector('.js-drawer-close');
        if (overlay) overlay.addEventListener('click', closeDrawer);
        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        if (autoOpen || wasOpen) openDrawer();
        bindDrawerItems();
      });
  }

  window.CartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    addItem: function (payload, callback) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add-failed');
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshDrawer(null, true);
          if (callback) callback(true);
        })
        .catch(function () {
          if (callback) callback(false);
        });
    }
  };

  function updateCartCount(count) {
    var badge = document.querySelector('.cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function changeLineItem(itemKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function bindDrawerItems() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;

    d.addEventListener('click', function (e) {
      var decBtn = e.target.closest('.js-qty-dec');
      var incBtn = e.target.closest('.js-qty-inc');
      var removeBtn = e.target.closest('.js-drawer-remove');

      if (decBtn || incBtn) {
        var stepper = (decBtn || incBtn).closest('.js-drawer-stepper');
        if (!stepper) return;
        var key = stepper.dataset.itemKey;
        var current = parseInt(stepper.dataset.quantity, 10) || 1;
        var newQty = decBtn ? Math.max(0, current - 1) : current + 1;
        stepper.dataset.quantity = newQty;
        var valEl = stepper.querySelector('.drawer-stepper__val');
        if (valEl) valEl.textContent = newQty;
        changeLineItem(key, newQty).then(function (cart) { refreshDrawer(cart); });
      }

      if (removeBtn) {
        var key = removeBtn.dataset.itemKey;
        changeLineItem(key, 0).then(function (cart) { refreshDrawer(cart); });
      }
    });
  }

  bindDrawerItems();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  var section = document.querySelector('.cart-page');
  if (!section) return;

  function formatMoney(pence) {
    var pounds = pence / 100;
    return '£' + (pounds % 1 === 0 ? String(Math.floor(pounds)) : pounds.toFixed(2));
  }

  function changeLineItem(key, qty, properties) {
    var body = { id: key, quantity: qty };
    if (properties !== undefined) body.properties = properties;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function updateSubtotal(cart) {
    var el = section.querySelector('.js-cart-subtotal');
    if (el && cart && cart.total_price !== undefined) {
      el.textContent = formatMoney(cart.total_price);
    }
    var badge = document.querySelector('.cart-count');
    if (badge && cart) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    }
    if (window.CartDrawer) window.CartDrawer.refresh(cart);
  }

  function removeItemRow(key) {
    var item = section.querySelector('.cart-item[data-item-key="' + key + '"]');
    if (item) item.remove();
    if (!section.querySelector('.cart-item')) window.location.reload();
  }

  function updateItemPrice(key, linePrice) {
    var item = section.querySelector('.cart-item[data-item-key="' + key + '"]');
    if (!item) return;
    var priceEl = item.querySelector('.cart-item__price');
    if (priceEl) priceEl.textContent = formatMoney(linePrice);
  }

  /* ─── Quantity steppers ─── */
  section.addEventListener('click', function (e) {
    var dec = e.target.closest('.js-cart-qty-dec');
    var inc = e.target.closest('.js-cart-qty-inc');
    if (!dec && !inc) return;
    var stepper = (dec || inc).closest('.js-cart-stepper');
    if (!stepper) return;
    var key = stepper.dataset.itemKey;
    var current = parseInt(stepper.dataset.quantity, 10) || 1;
    var newQty = dec ? Math.max(0, current - 1) : current + 1;

    if (newQty === 0) {
      changeLineItem(key, 0).then(function (cart) {
        removeItemRow(key);
        updateSubtotal(cart);
      });
      return;
    }

    stepper.dataset.quantity = newQty;
    var valEl = stepper.querySelector('.cart-stepper__val');
    if (valEl) valEl.textContent = newQty;

    changeLineItem(key, newQty).then(function (cart) {
      var found = cart.items && cart.items.find(function (i) { return i.key === key; });
      if (found) updateItemPrice(key, found.final_line_price);
      updateSubtotal(cart);
    });
  });

  /* ─── Remove items ─── */
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-cart-remove');
    if (!btn) return;
    changeLineItem(btn.dataset.itemKey, 0).then(function (cart) {
      removeItemRow(btn.dataset.itemKey);
      updateSubtotal(cart);
    });
  });

  /* ─── Gift messages ─── */
  section.addEventListener('click', function (e) {
    var wrap = e.target.closest('.js-gift-wrap');
    if (!wrap) return;
    var display = wrap.querySelector('.js-gift-display');
    var addBtn = wrap.querySelector('.js-gift-add');
    var editor = wrap.querySelector('.js-gift-editor');
    var textarea = wrap.querySelector('.js-gift-textarea');

    if (e.target.closest('.js-gift-add') || e.target.closest('.js-gift-edit')) {
      if (display) display.hidden = true;
      if (addBtn) addBtn.hidden = true;
      if (editor) editor.hidden = false;
      if (textarea) textarea.focus();
      return;
    }

    if (e.target.closest('.js-gift-cancel')) {
      if (editor) editor.hidden = true;
      if (display) display.hidden = false;
      if (addBtn) addBtn.hidden = false;
      return;
    }

    if (e.target.closest('.js-gift-save')) {
      var msg = textarea ? textarea.value.trim() : '';
      var key = wrap.dataset.itemKey;
      var qty = parseInt(wrap.dataset.qty, 10) || 1;
      changeLineItem(key, qty, { 'Gift message': msg }).then(function () {
        if (msg) {
          var textEl = wrap.querySelector('.js-gift-text');
          if (textEl) {
            textEl.textContent = msg;
            if (display) display.hidden = false;
          } else {
            var newDisplay = document.createElement('div');
            newDisplay.className = 'cart-item__gift-display js-gift-display';
            newDisplay.innerHTML =
              '<span class="cart-item__gift-label">Gift message:</span>' +
              '<span class="cart-item__gift-text js-gift-text">' + msg.replace(/</g, '&lt;') + '</span>' +
              '<span class="cart-item__gift-actions">' +
                '<button type="button" class="cart-item__gift-action js-gift-edit">Edit</button>' +
                '<button type="button" class="cart-item__gift-action cart-item__gift-action--remove js-gift-remove">Remove</button>' +
              '</span>';
            wrap.insertBefore(newDisplay, editor);
            if (addBtn) addBtn.remove();
          }
        } else {
          if (display) display.remove();
          if (!wrap.querySelector('.js-gift-add')) {
            var newAdd = document.createElement('button');
            newAdd.type = 'button';
            newAdd.className = 'cart-item__gift-add js-gift-add';
            newAdd.textContent = '+ Add a gift message';
            wrap.insertBefore(newAdd, editor);
          } else {
            addBtn.hidden = false;
          }
        }
        if (editor) editor.hidden = true;
      });
      return;
    }

    if (e.target.closest('.js-gift-remove')) {
      var removeKey = wrap.dataset.itemKey;
      var removeQty = parseInt(wrap.dataset.qty, 10) || 1;
      changeLineItem(removeKey, removeQty, { 'Gift message': '' }).then(function () {
        if (display) display.remove();
        if (!wrap.querySelector('.js-gift-add')) {
          var newAdd = document.createElement('button');
          newAdd.type = 'button';
          newAdd.className = 'cart-item__gift-add js-gift-add';
          newAdd.textContent = '+ Add a gift message';
          wrap.insertBefore(newAdd, wrap.querySelector('.js-gift-editor'));
        }
      });
    }
  });

  /* ─────────────────────────────────────────────────────────
     DELIVERY DATE CALENDAR
  ───────────────────────────────────────────────────────── */
  (function () {
    var calEl = section.querySelector('.js-delivery-cal');
    if (!calEl) return;

    /* Config from data attributes */
    var leadDays       = parseInt(calEl.dataset.lead, 10) || 2;
    var maxDays        = parseInt(calEl.dataset.max, 10) || 90;
    var cutoffEnabled  = calEl.dataset.cutoffEnabled === 'true';
    var cutoffTime     = calEl.dataset.cutoffTime || '20:00';
    var excludedRaw    = (calEl.dataset.excluded || '').replace(/,+$/, '');
    var excludedDays   = excludedRaw.length
      ? excludedRaw.split(',').map(Number).filter(function (n) { return !isNaN(n) && n >= 0 && n <= 6; })
      : [];
    var blockedRaw     = calEl.dataset.blocked || '';
    var blockedDates   = blockedRaw
      ? blockedRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      : [];
    var firstMonday    = calEl.dataset.firstMonday !== 'false';
    var timezone       = calEl.dataset.timezone || 'Europe/London';
    var existingRaw    = calEl.dataset.existing || '';

    /* DOM refs */
    var triggerBtn  = calEl.querySelector('.js-cal-trigger');
    var triggerText = calEl.querySelector('.js-cal-trigger-text');
    var panel       = calEl.querySelector('.js-cal-panel');
    var prevBtn     = calEl.querySelector('.js-cal-prev');
    var nextBtn     = calEl.querySelector('.js-cal-next');
    var monthLabel  = calEl.querySelector('.js-cal-month');
    var calHead     = calEl.querySelector('.js-cal-head');
    var calBody     = calEl.querySelector('.js-cal-body');
    var dateError   = section.querySelector('.js-date-error');

    /* State */
    var selectedDate = null;
    var viewYear, viewMonth;
    var minDate, maxDate;
    var isOpen = false;

    var MONTH_NAMES = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];
    var WEEKDAY_SHORT_MON = ['Mo','Tu','We','Th','Fr','Sa','Su'];
    var WEEKDAY_SHORT_SUN = ['Su','Mo','Tu','We','Th','Fr','Sa'];
    var WEEKDAY_LONG = [
      'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'
    ];

    /* ── Date helpers ── */

    function getTodayInTimezone() {
      var now = new Date();
      var s = now.toLocaleDateString('en-CA', { timeZone: timezone }); /* yyyy-mm-dd */
      var p = s.split('-');
      return new Date(+p[0], +p[1] - 1, +p[2]);
    }

    function getShopTime() {
      var now = new Date();
      var s = now.toLocaleTimeString('en-GB', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      var p = s.split(':');
      return { h: +p[0], m: +p[1] };
    }

    function calcMinDate() {
      var today = getTodayInTimezone();
      var ukDay = today.getDay(); /* 0=Sun 1=Mon … 6=Sat */
      var afterCutoff = false;
      if (cutoffEnabled) {
        var cp = cutoffTime.split(':');
        var cutH = +cp[0];
        var cutM = cp[1] ? +cp[1] : 0;
        var now = getShopTime();
        afterCutoff = now.h * 60 + now.m >= cutH * 60 + cutM;
      }
      /*
       * Day-of-week offset table (index = JS getDay(), 0=Sun):
       *   Sun  before 20:00 → +3 (Wed)   after → +4 (Thu)
       *   Mon  before 20:00 → +3 (Thu)   after → +4 (Fri)
       *   Tue  before 20:00 → +3 (Fri)   after → +4 (Sat)
       *   Wed  before 20:00 → +3 (Sat)   after → +7 (next Wed)
       *   Thu  any          → +6 (next Wed)
       *   Fri  any          → +5 (next Wed)
       *   Sat  any          → +4 (next Wed)
       */
      var offsetsBefore = [3, 3, 3, 3, 6, 5, 4];
      var offsetsAfter  = [4, 4, 4, 7, 6, 5, 4];
      var offset = afterCutoff ? offsetsAfter[ukDay] : offsetsBefore[ukDay];
      var d = new Date(today);
      d.setDate(d.getDate() + offset);
      return d;
    }

    function isSundayDisabledByWedCutoff(d) {
      /* The Wednesday of d's Mon–Sun week is d − 4 days */
      var wed = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 4);
      var today = getTodayInTimezone();
      if (today > wed) return true;
      if (today.getTime() === wed.getTime()) {
        var cp = cutoffTime.split(':');
        var cutH = +cp[0];
        var cutM = cp[1] ? +cp[1] : 0;
        var now = getShopTime();
        return now.h * 60 + now.m >= cutH * 60 + cutM;
      }
      return false;
    }

    function calcMaxDate() {
      var today = getTodayInTimezone();
      var d = new Date(today);
      d.setDate(d.getDate() + maxDays);
      return d;
    }

    function toDateKey(d) {
      /* dd/mm/yyyy — matches merchant's blocked-dates input format */
      return (
        String(d.getDate()).padStart(2, '0') + '/' +
        String(d.getMonth() + 1).padStart(2, '0') + '/' +
        d.getFullYear()
      );
    }

    function toIsoDate(d) {
      return (
        d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0')
      );
    }

    function toFriendlyDate(d) {
      return (
        WEEKDAY_LONG[d.getDay()] + ', ' +
        d.getDate() + ' ' +
        MONTH_NAMES[d.getMonth()] + ' ' +
        d.getFullYear()
      );
    }

    function isAvailable(d) {
      var day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      if (day < minDate || day > maxDate) return false;
      if (excludedDays.length && excludedDays.indexOf(d.getDay()) !== -1) return false;
      if (cutoffEnabled && d.getDay() === 0 && isSundayDisabledByWedCutoff(d)) return false;
      if (blockedDates.length && blockedDates.indexOf(toDateKey(d)) !== -1) return false;
      return true;
    }

    function sameDay(a, b) {
      return (
        a && b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    }

    function parseExistingDate(str) {
      if (!str) return null;
      /* ISO yyyy-mm-dd (legacy format from old input) */
      if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        var p = str.split('-');
        return new Date(+p[0], +p[1] - 1, +p[2]);
      }
      /* Friendly "Friday, 20 June 2026" or "20 June 2026" */
      var m = str.match(/(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})/);
      if (m) {
        var attempt = new Date(m[1] + ' ' + m[2] + ' ' + m[3]);
        if (!isNaN(attempt.getTime())) return attempt;
      }
      return null;
    }

    /* ── Render ── */

    function buildHeader() {
      calHead.innerHTML = '';
      var days = firstMonday ? WEEKDAY_SHORT_MON : WEEKDAY_SHORT_SUN;
      days.forEach(function (label) {
        var th = document.createElement('th');
        th.scope = 'col';
        th.className = 'delivery-cal__weekday';
        th.setAttribute('aria-label', label);
        th.textContent = label;
        calHead.appendChild(th);
      });
    }

    function colForDay(jsDay) {
      /* Returns 0-6 column index */
      return firstMonday ? (jsDay + 6) % 7 : jsDay;
    }

    function renderMonth() {
      monthLabel.textContent = MONTH_NAMES[viewMonth] + ' ' + viewYear;

      var firstDay  = new Date(viewYear, viewMonth, 1);
      var lastDay   = new Date(viewYear, viewMonth + 1, 0);
      var startCol  = colForDay(firstDay.getDay());
      var totalCells = 42; /* 6 rows × 7 cols */

      calBody.innerHTML = '';

      var focusCellSet = false;

      for (var i = 0; i < totalCells; i++) {
        var col = i % 7;
        if (col === 0) calBody.appendChild(document.createElement('tr'));
        var tr = calBody.lastElementChild;

        var td   = document.createElement('td');
        var span = document.createElement('span');
        td.className = 'delivery-cal__day';
        td.setAttribute('role', 'gridcell');

        var dayNum   = i - startCol + 1;
        var cellDate = new Date(viewYear, viewMonth, dayNum);
        var inMonth  = dayNum >= 1 && dayNum <= lastDay.getDate();

        span.textContent = cellDate.getDate();
        td.appendChild(span);

        if (!inMonth) {
          td.classList.add('delivery-cal__day--outside');
          td.setAttribute('aria-hidden', 'true');
          td.setAttribute('tabindex', '-1');
        } else {
          td.setAttribute('aria-label', toFriendlyDate(cellDate));

          if (isAvailable(cellDate)) {
            td.classList.add('delivery-cal__day--available');
            td.dataset.date = toIsoDate(cellDate);

            if (sameDay(cellDate, selectedDate)) {
              td.classList.add('delivery-cal__day--selected');
              td.setAttribute('aria-selected', 'true');
              td.setAttribute('tabindex', '0');
              focusCellSet = true;
            } else {
              td.setAttribute('aria-selected', 'false');
              td.setAttribute('tabindex', '-1');
            }
          } else {
            td.classList.add('delivery-cal__day--disabled');
            td.setAttribute('aria-disabled', 'true');
            td.setAttribute('tabindex', '-1');
          }
        }

        tr.appendChild(td);
      }

      /* Ensure one cell is in the tab sequence for keyboard entry */
      if (!focusCellSet) {
        var first = calBody.querySelector('.delivery-cal__day--available');
        if (first) first.setAttribute('tabindex', '0');
      }

      /* Disable nav buttons at window boundaries */
      var minFirst = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      var maxFirst = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
      var curFirst = new Date(viewYear, viewMonth, 1);
      prevBtn.disabled = curFirst <= minFirst;
      nextBtn.disabled = curFirst >= maxFirst;
    }

    /* ── Open / close ── */

    function openCalendar() {
      if (isOpen) return;
      isOpen = true;
      panel.hidden = false;
      triggerBtn.setAttribute('aria-expanded', 'true');
      /* Focus roving cell after paint */
      requestAnimationFrame(function () {
        var target = calBody.querySelector('[tabindex="0"]');
        if (target) target.focus();
      });
    }

    function closeCalendar() {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
      triggerBtn.setAttribute('aria-expanded', 'false');
    }

    /* ── Selection ── */

    function selectDate(d) {
      selectedDate = d;
      var friendly = toFriendlyDate(d);

      triggerText.textContent = friendly;
      triggerText.classList.add('delivery-cal__trigger-text--selected');
      calEl.dataset.selectedDate = toIsoDate(d);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery Date': toIsoDate(d) } })
      });

      if (dateError) dateError.hidden = true;
      var checkoutErr = section.querySelector('.js-checkout-date-error');
      if (checkoutErr) checkoutErr.hidden = true;
      triggerBtn.removeAttribute('aria-invalid');

      renderMonth();
      closeCalendar();
    }

    /* ── Keyboard navigation ── */

    function moveFocus(from, delta) {
      var cells = Array.from(calBody.querySelectorAll('.delivery-cal__day:not(.delivery-cal__day--outside)'));
      var idx = cells.indexOf(from);
      var next = cells[idx + delta];
      if (!next) return;
      from.setAttribute('tabindex', '-1');
      next.setAttribute('tabindex', '0');
      next.focus();
    }

    function handlePanelKey(e) {
      var current = document.activeElement;

      /* Navigation buttons can use normal tab */
      if (current === prevBtn || current === nextBtn) return;

      if (!calBody.contains(current)) return;

      switch (e.key) {
        case 'ArrowRight': e.preventDefault(); moveFocus(current, 1); break;
        case 'ArrowLeft':  e.preventDefault(); moveFocus(current, -1); break;
        case 'ArrowDown':  e.preventDefault(); moveFocus(current, 7); break;
        case 'ArrowUp':    e.preventDefault(); moveFocus(current, -7); break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (current.classList.contains('delivery-cal__day--available')) {
            var iso = current.dataset.date;
            if (iso) {
              var p = iso.split('-');
              selectDate(new Date(+p[0], +p[1] - 1, +p[2]));
            }
          }
          break;
        case 'Escape':
          e.preventDefault();
          closeCalendar();
          triggerBtn.focus();
          break;
      }
    }

    /* ── Events ── */

    triggerBtn.addEventListener('click', function () {
      if (isOpen) closeCalendar(); else openCalendar();
    });

    prevBtn.addEventListener('click', function () {
      if (viewMonth === 0) { viewMonth = 11; viewYear--; }
      else viewMonth--;
      renderMonth();
      /* Keep focus in nav */
      prevBtn.focus();
    });

    nextBtn.addEventListener('click', function () {
      if (viewMonth === 11) { viewMonth = 0; viewYear++; }
      else viewMonth++;
      renderMonth();
      nextBtn.focus();
    });

    calBody.addEventListener('click', function (e) {
      var cell = e.target.closest('.delivery-cal__day--available');
      if (!cell) return;
      var iso = cell.dataset.date;
      if (!iso) return;
      var p = iso.split('-');
      selectDate(new Date(+p[0], +p[1] - 1, +p[2]));
    });

    panel.addEventListener('keydown', handlePanelKey);

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (isOpen && !calEl.contains(e.target)) closeCalendar();
    });

    /* ── Init ── */

    minDate = calcMinDate();
    maxDate = calcMaxDate();

    /* Pre-select existing date if valid */
    if (existingRaw) {
      var parsed = parseExistingDate(existingRaw);
      if (parsed && isAvailable(parsed)) {
        selectedDate = parsed;
        calEl.dataset.selectedDate = toIsoDate(parsed);
        triggerText.textContent = toFriendlyDate(parsed);
        triggerText.classList.add('delivery-cal__trigger-text--selected');
      } else if (parsed) {
        /* Existing date is no longer bookable — clear the cart attribute silently */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Delivery Date': '' } })
        });
        triggerText.textContent = 'Choose your delivery date';
      }
    }

    /* Start calendar at selected month, or earliest available month */
    var viewStart = selectedDate || minDate;
    viewYear  = viewStart.getFullYear();
    viewMonth = viewStart.getMonth();

    buildHeader();
    renderMonth();
  })();

  /* ─── Checkout validation ─── */
  var checkoutBtn = section.querySelector('.js-cart-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      var calEl = section.querySelector('.js-delivery-cal');
      if (calEl && calEl.dataset.selectedDate) return;
      e.preventDefault();
      var checkoutErr = section.querySelector('.js-checkout-date-error');
      if (checkoutErr) {
        checkoutErr.textContent = 'Please choose a delivery date before checking out.';
        checkoutErr.hidden = false;
      }
      var picker = section.querySelector('.cart-delivery-date');
      if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (calEl) {
        var trigger = calEl.querySelector('.js-cal-trigger');
        if (trigger) {
          trigger.focus();
          trigger.setAttribute('aria-invalid', 'true');
        }
      }
    });
  }

  /* ─── Upsell ─── */
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-upsell-add');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓';
        btn.classList.add('is-added');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateSubtotal(cart); })
      .catch(function () { btn.disabled = false; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      window.location.search = params.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburger = document.querySelector('.header-hamburger');
    var mobileNav = document.getElementById('mobile-nav');

    if (!hamburger || !mobileNav) return;

    var labelOpen = hamburger.getAttribute('data-label-open') || 'Open menu';
    var labelClose = hamburger.getAttribute('data-label-close') || 'Close menu';

    hamburger.addEventListener('click', function () {
      var expanded = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', (!expanded).toString());
      hamburger.setAttribute('aria-label', expanded ? labelOpen : labelClose);
      if (expanded) {
        mobileNav.setAttribute('hidden', '');
      } else {
        mobileNav.removeAttribute('hidden');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mobileNav.hasAttribute('hidden')) {
        mobileNav.setAttribute('hidden', '');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', labelOpen);
        hamburger.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
(function () {
  var popup = document.querySelector('.js-newsletter-popup');
  if (!popup) return;

  if (/^\/(cart|checkout)(\/|$)/.test(window.location.pathname)) return;

  var COOKIE_NAME = 'rb_newsletter_popup';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  var overlay = popup.querySelector('.js-popup-overlay');
  var closeBtn = popup.querySelector('.js-popup-close');
  var copyBtn = popup.querySelector('.js-popup-copy');
  var triggerEl = null;

  function handleKeyDown(e) {
    if (e.key === 'Escape') { closePopup(true); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(
      popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function openPopup() {
    triggerEl = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    var focusTarget = popup.querySelector('input, button');
    if (focusTarget) focusTarget.focus();
    document.addEventListener('keydown', handleKeyDown);
  }

  function closePopup(suppress) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', handleKeyDown);
    if (triggerEl && triggerEl.focus) triggerEl.focus();
    if (suppress && !getCookie(COOKIE_NAME)) setCookie(COOKIE_NAME, 'dismissed', 30);
  }

  /* Shopify's native cookie/privacy consent banner appears on first load too —
     never show both at once. Detect it (DOM presence, not just existence, since
     some implementations hide it via CSS rather than removing it) and hold the
     popup back until it's been resolved, using the documented Customer Privacy
     API consent event as the primary signal and a DOM observer as a fallback
     for banner implementations that don't fire it. */
  function consentBannerVisible() {
    var el = document.querySelector('#shopify-pc__banner, [id^="shopify-pc__"]');
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  var bannerCleared = !consentBannerVisible();
  var wantsToOpen = false;

  function tryOpen() {
    if (!wantsToOpen || !bannerCleared) return;
    openPopup();
  }

  if (!bannerCleared) {
    document.addEventListener('visitorConsentCollected', function () {
      bannerCleared = true;
      tryOpen();
    }, { once: true });

    var consentObserver = new MutationObserver(function () {
      if (!consentBannerVisible()) {
        bannerCleared = true;
        consentObserver.disconnect();
        tryOpen();
      }
    });
    consentObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  if (overlay) overlay.addEventListener('click', function () { closePopup(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { closePopup(true); });

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.dataset.code || '';
      var onCopied = function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = copyBtn.dataset.copiedLabel || original;
        copyBtn.classList.add('is-copied');
        setTimeout(function () {
          copyBtn.textContent = original;
          copyBtn.classList.remove('is-copied');
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(onCopied).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); onCopied(); } catch (_) {}
        document.body.removeChild(ta);
      }
    });
  }

  /* Already subscribed this page load (native customer-form round-trip) —
     open immediately (once any consent banner clears) in the success state
     and lock out future prompts. */
  if (popup.dataset.justSubscribed === 'true') {
    setCookie(COOKIE_NAME, 'subscribed', 365);
    wantsToOpen = true;
    tryOpen();
    return;
  }

  /* Never re-prompt someone who already dismissed or subscribed */
  if (getCookie(COOKIE_NAME)) return;

  var delaySeconds = parseFloat(popup.dataset.delay);
  if (isNaN(delaySeconds)) delaySeconds = 5;
  var opened = false;

  function triggerOpen() {
    if (opened) return;
    opened = true;
    clearTimeout(timerId);
    window.removeEventListener('scroll', onScroll);
    wantsToOpen = true;
    tryOpen();
  }

  function onScroll() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    if ((window.scrollY / scrollable) > 0.5) triggerOpen();
  }

  var timerId = setTimeout(triggerOpen, delaySeconds * 1000);
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
